module.exports = __webpack_public_path__ + "static/media/correct-3.bda465e0.mp3";